export class ColumnList {
    shareholder: boolean;
    fdbShares: boolean;
    preHoldingPercentage: boolean;
    postHoldingPercentage: boolean;
    preHoldingShares: boolean;
    postHoldingShares: boolean;
    amountReceived: boolean;
}